export function subtractYears(date, years) {
    let newDate = new Date(date);
    newDate.setFullYear(date.getFullYear() - years);
    return newDate;
}
